module.exports = __webpack_public_path__ + "static/media/Albus Dumbledore 2.1d2121b8.jpg";